import { JQueryHelperService } from "./../../shared/models/jquery-helper.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import {
  VehicleModel,
  VehicleBlockModel,
  SVGVehicleModel,
  VTSVehicleModel
} from "./vehicle.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";

@Injectable()
export class VehicleService {
  private JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) {}

  public GetVehicleList(
    input?: DataListModel,
    ownerCompanyHashID?: string,
    sharedVehicleGroupHashId?: string,
    instanceHashId?: string,
    forSnailTrailReport: boolean = false,
    chkCleanRequireFilter: boolean = false,
    chkFuelRequireFilter: boolean = false,
    chkDamageFilter: boolean = false,
    permissionName: string = ""
  ): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VEHICLE_LIST + "?";
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) getVehicleUrl = getVehicleUrl + queryString;

    if (instanceHashId)
      getVehicleUrl = getVehicleUrl + "&instanceHashId=" + instanceHashId;

    if (ownerCompanyHashID)
      getVehicleUrl =
        getVehicleUrl + "&ownerCompanyHashID=" + ownerCompanyHashID;

    if (sharedVehicleGroupHashId)
      getVehicleUrl =
        getVehicleUrl + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;

    getVehicleUrl =
      getVehicleUrl + "&ForSnailTrailReport=" + forSnailTrailReport;

    getVehicleUrl =
      getVehicleUrl + "&CleanRequireFilter=" + chkCleanRequireFilter;
    getVehicleUrl =
      getVehicleUrl + "&FuelRequireFilter=" + chkFuelRequireFilter;
    getVehicleUrl = getVehicleUrl + "&DamageFilter=" + chkDamageFilter;

    if (permissionName)
      getVehicleUrl = getVehicleUrl + "&permissionName=" + permissionName;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVehicleList(
    input?: DataListModel,
    ownerCompanyHashID?: string,
    sharedVehicleGroupHashId?: string,
    instanceHashId?: string,
    forSnailTrailReport: boolean = false,
    chkCleanRequireFilter: boolean = false,
    chkFuelRequireFilter: boolean = false,
    chkDamageFilter: boolean = false,
    permissionName: string = ""
  ): any {
    input.currentPage = 0;

    let getVehicleUrl = WeGoConfig.API_EXPORT_VEHICLE_LIST + "?";
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) getVehicleUrl = getVehicleUrl + queryString;

    if (instanceHashId)
      getVehicleUrl = getVehicleUrl + "&instanceHashId=" + instanceHashId;

    if (ownerCompanyHashID)
      getVehicleUrl =
        getVehicleUrl + "&ownerCompanyHashID=" + ownerCompanyHashID;

    if (sharedVehicleGroupHashId)
      getVehicleUrl =
        getVehicleUrl + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;

    getVehicleUrl =
      getVehicleUrl + "&ForSnailTrailReport=" + forSnailTrailReport;

    getVehicleUrl =
      getVehicleUrl + "&CleanRequireFilter=" + chkCleanRequireFilter;
    getVehicleUrl =
      getVehicleUrl + "&FuelRequireFilter=" + chkFuelRequireFilter;
    getVehicleUrl = getVehicleUrl + "&DamageFilter=" + chkDamageFilter;

    if (permissionName)
      getVehicleUrl = getVehicleUrl + "&permissionName=" + permissionName;

    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVehicleUrl, options);
  }

  public ExportSVGDriverList(
    ownerCompanyHashID?: string,
    sharedVehicleGroupHashId?: string,
    input?: DataListModel
  ): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getVehicleUrl = WeGoConfig.API_EXPORT_SVG_DRIVER_LIST;
    if (ownerCompanyHashID) {
      getVehicleUrl =
        getVehicleUrl +
        "?" +
        queryString +
        "&ownerCompanyHashID=" +
        ownerCompanyHashID;
    } else if (sharedVehicleGroupHashId) {
      getVehicleUrl =
        getVehicleUrl +
        "?" +
        queryString +
        "&sharedVehicleGroupHashId=" +
        sharedVehicleGroupHashId;
    } else {
      getVehicleUrl = getVehicleUrl + "?" + queryString;
    }

    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVehicleUrl, options);
  }

  public GetVehicleByHashId(
    vehicleHashId: string,
    isEditMode: boolean
  ): Observable<IAPIResponse> {
    let getVehicleUrl =
      WeGoConfig.API_GET_VEHICLE_BY_HASH +
      "?vehicleHashId=" +
      vehicleHashId +
      "&isEditMode=" +
      isEditMode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateVehicleMaster(bodyData: any): Observable<IAPIResponse> {
    let body = bodyData;
    let headers = this.authService.GetHeader(
      "application/json",
      "application/x-www-form-urlencoded"
    );
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_VEHICLE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddNewVehicle(vehicleModel: VehicleModel): Observable<IAPIResponse> {
    let body = vehicleModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_VEHICLE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteVehicle(selectedVehicles: string[]): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_DELETE_VEHICLES, selectedVehicles, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  // public GetVehicleSVGList(
  //   vehicleHashId: string,
  //   input?: DataListModel
  // ): Observable<IAPIResponse> {
  //   let getDriverUrl = WeGoConfig.API_GET_VEHICLE_SVG_LIST;
  //   let queryString = this.authService.HandleAPIListInput(input);
  //   if (queryString) {
  //     getDriverUrl =
  //       getDriverUrl + "?" + queryString + "&vehicleHashId=" + vehicleHashId;
  //   } else {
  //     getDriverUrl = getDriverUrl + "?vehicleHashId=" + vehicleHashId;
  //   }
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });
  //   return this.http
  //     .get(getDriverUrl, options)
  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }

  // public ExportVehicleSVGList(vehicleHashId: string): any {
  //   let getInstanceUrl =
  //     WeGoConfig.API_EXPORT_VEHICLE_SVG_LIST +
  //     "?vehicleHashId=" +
  //     vehicleHashId;
  //   let headers = this.authService.GetHeader("text/csv");
  //   let options = new RequestOptions({ headers: headers });
  //   return this.http.get(getInstanceUrl, options);
  // }

  public DeleteVehicleSVG(
    selectedVehicleSVGList: string[]
  ): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(
        WeGoConfig.API_POST_DELETE_VEHICLE_SVG,
        selectedVehicleSVGList,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AssignSVGToVehicle(
    SVGvehicleModel: SVGVehicleModel
  ): Observable<IAPIResponse> {
    let body = SVGvehicleModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_SVG_VEHICLE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public BlockUnBlockVehicle(
    vehicleBlockModel: VehicleBlockModel
  ): Observable<IAPIResponse> {
    let body = vehicleBlockModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_VEHICLE_BLOCK, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleListBySVGID(
    input?: DataListModel,
    sharedVehicleGroupHashId?: string
  ): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VEHICLE_LIST_BY_SVGID;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getVehicleUrl = getVehicleUrl + "?" + queryString;
      if (sharedVehicleGroupHashId)
        getVehicleUrl =
          getVehicleUrl +
          "&sharedVehicleGroupHashId=" +
          sharedVehicleGroupHashId;
    } else {
      if (sharedVehicleGroupHashId)
        getVehicleUrl =
          getVehicleUrl +
          "?sharedVehicleGroupHashId=" +
          sharedVehicleGroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBookingOverviewList(
    vehicleModel: VehicleModel,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let body  = vehicleModel;
    let getBookingOverviewUrl = WeGoConfig.API_GET_AFFECTEDBOOKING;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let queryStringBookingOverviewModel = this.JQueryHelper.Param(vehicleModel);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingOverviewUrl =
      getBookingOverviewUrl +
      "?" +
      queryStringDataListModel//?// +
      ///"&" +
      ///decodeURIComponent(queryStringBookingOverviewModel);
    return this.http
      .post(getBookingOverviewUrl, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddNewVtsVehicle(
    vehicleModel: VTSVehicleModel
  ): Observable<IAPIResponse> {
    let body = vehicleModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_VTSVEHICLE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVTSVehicleList(input?: DataListModel): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VTS_VEHICLE_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getVehicleUrl = getVehicleUrl + "?" + queryString;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVtsVehicleByHashId(
    vehicleHashId: string
  ): Observable<IAPIResponse> {
    let getVehicleUrl =
      WeGoConfig.API_GET_VTSVEHICLE_BY_HASH + "?vehicleHashId=" + vehicleHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetAllVtsVehicleList(input?: DataListModel): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VTSVEHICLE_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getVehicleUrl = getVehicleUrl + "?" + queryString;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportVTSVehicleList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_VTSVEHICLE_SVG_LIST + "?" + queryString;
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  // public UpdateVTSVehicleStatus(vehicleHashId: string, vehicleStatus: string): Observable<IAPIResponse> {
  //   let updateVtsVehicleUrl = WeGoConfig.API_UPDATE_VTS_VEHICLE_STATUS;
  //   updateVtsVehicleUrl = updateVtsVehicleUrl + "?vehicleHashId=" + vehicleHashId + "&vehicleStatus=" + vehicleStatus;
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });
  //   return this.http.get(updateVtsVehicleUrl, options)
  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }

  public UnLockVTSVehicle(
    vehicleHashId: string,
    isMobileRequest: boolean
  ): Observable<IAPIResponse> {
    let updateVtsVehicleUrl = WeGoConfig.API_UNLOCK_VTS_VEHICLE;
    updateVtsVehicleUrl =
      updateVtsVehicleUrl +
      "?vehicleHashId=" +
      vehicleHashId +
      "&isMobileRequest=" +
      isMobileRequest;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(updateVtsVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public LockVTSVehicle(
    vehicleHashId: string,
    isMobileRequest: boolean
  ): Observable<IAPIResponse> {
    let updateVtsVehicleUrl = WeGoConfig.API_LOCK_VTS_VEHICLE;
    updateVtsVehicleUrl =
      updateVtsVehicleUrl +
      "?vehicleHashId=" +
      vehicleHashId +
      "&isMobileRequest=" +
      isMobileRequest;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(updateVtsVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleDamageReport(
    vehicleHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VEHICLE_DAMAGE_REPORT_BY_HASH;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getVehicleUrl =
        getVehicleUrl + "?" + queryString + "&vehicleHashId=" + vehicleHashId;
    } else {
      getVehicleUrl = getVehicleUrl + "?vehicleHashId=" + vehicleHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateReportDamageStatus(
    reportDamageHashId: string
  ): Observable<IAPIResponse> {
    let getDamgeReportUrl =
      WeGoConfig.API_UPDATE_REPORT_DAMAGE_STATUS +
      "?reportDamageHashId=" +
      reportDamageHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getDamgeReportUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleFutureBookingList(
    vehicleHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_VEHICLE_FUTURE_BOOKING_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverUrl =
        getDriverUrl + "?" + queryString + "&vehicleHashId=" + vehicleHashId;
    } else {
      getDriverUrl = getDriverUrl + "?vehicleHashId=" + vehicleHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateVehicleInfo(
    vehicleModel: VehicleModel
  ): Observable<IAPIResponse> {
    let body = vehicleModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_VEHICLE_INFO, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateVehicleForCleaningAndFuel(
    vehicleHashId: string,
    isCleaningNeed: boolean,
    isFuelNeed: boolean
  ): Observable<IAPIResponse> {
    let updateVehicleCleaningAndFuel =
      WeGoConfig.API_UPDATE_VEHICLE_FOR_CLEANING_AND_FUEL +
      "?vehicleHashId=" +
      vehicleHashId +
      "&isCleaningNeed=" +
      isCleaningNeed +
      "&isFuelNeed=" +
      isFuelNeed;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(updateVehicleCleaningAndFuel, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateVehicleForInvalidTag(
    vehicleHashId: string,
    invalidTagUsed: boolean
  ): Observable<IAPIResponse> {
    let UpdateVehicleForInvalidTag =
      WeGoConfig.API_UPDATE_VEHICLE_FOR_INVALID_TAG_USED +
      "?vehicleHashId=" +
      vehicleHashId +
      "&invalidTagUsed=" +
      invalidTagUsed;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(UpdateVehicleForInvalidTag, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownVehicleList(
    reportName: string,
    instanceHashId: string,
    companyHashId: string,
    sharedVehicleGroupHashId: string
  ): Observable<IAPIResponse> {
    let getVehicleListUrl: string;

    switch (reportName) {
      case "Vehicle_Occupancy_Report":
        getVehicleListUrl =
          WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_VEHICLEOCCUPANCYREPORT;
        break;
      case "Revenue_Per_Vehicle_Report":
        getVehicleListUrl =
          WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_REVENUEVEHICLEREPORT;
        break;
      case "Maintenance_Planning_Report":
        getVehicleListUrl =
          WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_MAINTENCEPLANNINGREPORT;
        break;
      case "TripData_Report":
        getVehicleListUrl =
          WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_TRIPDATAREPORT;
        break;
      case "Kick_Back_Report":
        getVehicleListUrl =
          WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_KICKBACKREPORT;
        break;
      default:
        getVehicleListUrl =
          WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_VEHICLEOCCUPANCYREPORT;
        break;
    }

    getVehicleListUrl =
      getVehicleListUrl +
      "?instanceHashId=" +
      instanceHashId +
      "&companyHashId=" +
      companyHashId +
      "&sharedVehicleGroupHashId=" +
      sharedVehicleGroupHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleDropdownListBySVGID(
    sharedVehicleGroupHashId?: string
  ): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_VEHICLE_DROPDOWN_LIST_BY_SVGID;

    if (sharedVehicleGroupHashId)
      getVehicleUrl =
        getVehicleUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetVehicleListByOrganization(
    input?: DataListModel,
    customerHashId: string = "",
    instanceHashId: string = "",
    companyHashId: string = "",
    organizationHashId: string = "",
    svgHashId: string = "",
    pageName: string = ""
  ): Observable<IAPIResponse> {
    let getVehicleUrl: string = "";

    switch (pageName) {
      case "Cost_Center_Report":
        getVehicleUrl =
          WeGoConfig.API_GET_VEHICLE_LIST_FOR_COST_CENTER_REPORT + "?";
        break;

      default:
        getVehicleUrl =
          WeGoConfig.API_GET_VEHICLE_LIST_FOR_COST_CENTER_REPORT + "?";
        break;
    }

    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) getVehicleUrl = getVehicleUrl + queryString;

    if (customerHashId)
      getVehicleUrl = getVehicleUrl + "&customerHashId=" + customerHashId;

    if (instanceHashId)
      getVehicleUrl = getVehicleUrl + "&instanceHashId=" + instanceHashId;

    if (companyHashId)
      getVehicleUrl = getVehicleUrl + "&companyHashId=" + companyHashId;

    if (svgHashId) getVehicleUrl = getVehicleUrl + "&svgHashId=" + svgHashId;

    if (organizationHashId)
      getVehicleUrl =
        getVehicleUrl + "&organizationHashId=" + organizationHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/vehicle/models/vehicle.service.ts